import { useContext } from "react";
//Common
import FormBackGround from "../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../common/Forms/FormHeader/FormHeader";
import DisplayData from "../common/DisplayData/DisplayData";
import { BlockIcon, ActivateIcon } from "../common/Icons";
import { Button } from "../common/VFX-UI";
//App
import { AgencyContext } from "./AgencyContainer";
import useComponentGeneralStyles from "../styles";
import { EMPTY_GUID } from "../../utility/constants/constants";
import { AgencyViewProps } from "../../types/agency";

const AgencyView = (props: AgencyViewProps) => {
    const {
        onClose,
        editAction,
        toggleActivateHandler,
        toggleDeactivateHandler,
    } = props;
    const agencyContext = useContext(AgencyContext);
    const generalStyles = useComponentGeneralStyles();

    const agency = agencyContext?.data;

    const hasManageEmployeesPermission =
        agencyContext?.hasManageAgenciesPermission;

    return (
        <FormBackGround>
            <FormHeader
                title={`${agency?.name}`}
                chipLabel={agency?.isActive ? "Active" : "Inactive"}
                onClose={onClose}
                editActionHandler={
                    hasManageEmployeesPermission && agency?.isActive ? editAction : undefined
                }
            />
            <>
                <DisplayData
                    text="Description"
                    importedData={agency?.description}
                />
            </>
            <div className="border-top container-fluid p-3 mt-auto">
                {hasManageEmployeesPermission &&
                    agency?.id &&
                    agency?.id !== EMPTY_GUID &&
                    !agency?.isActive && (
                        <Button
                            style={generalStyles.activateButton}
                            onClick={toggleActivateHandler}
                        >
                            <ActivateIcon />
                        </Button>
                    )}
                {hasManageEmployeesPermission &&
                    agency?.id &&
                    agency?.id !== EMPTY_GUID &&
                    agency?.isActive && (
                        <Button
                            style={generalStyles.deleteButton}
                            onClick={toggleDeactivateHandler}
                        >
                            <BlockIcon />
                        </Button>
                    )}
            </div>
        </FormBackGround>
    );
};

export default AgencyView;
